import React, { useEffect } from "react";
import { useCustomer } from "hooks/useStore";
import ProductItem from "components/product/item";
import { trackViewItemList } from "analytics";
import { useInView } from "react-intersection-observer";
import ImageLink from "./image-link";
import clsx from "clsx/lite";

const SubCategoryItem = ({ data, activeIndex, className, itemClassName, limitItems }) => {
	const { ref, inView } = useInView({ threshold: 0, triggerOnce: true });
	const activeCategory = data.categoryLinks?.[activeIndex];
	const customer = useCustomer();

	useEffect(() => {
		if (!inView) return;
		if (activeCategory?.categoryLinks?.length > 0
			&& activeCategory?.categoryLinks.some((item) => item._type === "productLink"))
			trackViewItemList(
				activeCategory?.categoryLinks.map((item) => item._type === "productLink" && item.product),
				{ title: "Menu Category", handle: location.pathname },
				customer);
	}, [inView, activeIndex, data.categoryLinks]);

	return (
		<div ref={ref} className="flex flex-col overflow-auto w-full no-scrollbar" key={data._key}>
			{activeCategory?.description &&
				<p className="text-secondary pb-3 text-xs">
					{data.categoryLinks[activeIndex].description}
				</p>}
			<div className={clsx("flex flex-0 gap-4 justify-start no-scrollbar", className)}>
				{activeCategory?.categoryLinks?.map((item, index) => {

					if (item._type === "productLink" && item.product)
						return (
							<div key={index}
								className={clsx("w-40 lg:w-60 flex", itemClassName,
									index === limitItems && "hidden xxl:flex")}>
								<ProductItem
									index={index + 1}
									product={item.product}
									customTitle={item.customTitle}
									titleClass="header-product-item"
									priceClass="text-xs ml-2 text-end md:text-sm"
									showViewDetails={false}
									source="header-menu"
									showModal={false} />
							</div>
						);

					if (item._type == "imageLink")
						return (
							<div key={item?._key} className="w-1/3">
								<ImageLink data={item} />
							</div>
						);

				})}
			</div>
		</div>
	);
};

export default SubCategoryItem;